// extracted by mini-css-extract-plugin
module.exports = {"mobile__menu__item":"br_fX","mobile__menu__link":"br_fY","mobile__menu__link__active":"br_fZ"};